import axios from 'axios'
import Cookies from 'js-cookie'
import useSWR from 'swr'

import { API_PARAMS } from '../../../config/consts'
import useFilterFutureDates from './useFilterFutureDates'

interface GetRewardCountRedeemedRequest {
  serviceId: string
  campaignId?: string | null
  fromDate?: string | null // '2021-01-01'
  toDate?: string | null // '2021-01-02'
}

interface GetRewardCountRedeemedResponse {
  statusCode: number
  statusMessage: string
  currentPeriodValue: number
  previousPeriodValue: number
  rewardCountRedeemedDatas: {
    date: string
    value: number
  }[]
}

const useGetRewardCountRedeemed = ({ serviceId, campaignId, fromDate, toDate }: GetRewardCountRedeemedRequest) => {
  const accessToken = Cookies.get('LoginToken')
  const fetcher = (url: string): Promise<GetRewardCountRedeemedResponse> => axios.get(url).then((res) => res.data)

  const url = new URL(`${process.env.REACT_APP_CITRUS_API_DOMAIN}/api/getRewardCountRedeemed`)
  url.searchParams.append('accessToken', accessToken ?? '')
  url.searchParams.append('serviceId', serviceId)
  if (fromDate && fromDate !== '') url.searchParams.append('fromDate', fromDate)
  if (toDate && toDate !== '') url.searchParams.append('toDate', toDate)
  url.searchParams.append('campaignId', campaignId ?? API_PARAMS.SELECT_ALL)

  const { data, isLoading, mutate } = useSWR(
    () => accessToken && serviceId && fromDate && toDate && campaignId && url.href,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
    },
  )

  const filteredData = useFilterFutureDates(data?.rewardCountRedeemedDatas)

  const resultData = data ? {
    ...data,
    rewardCountRedeemedDatas: filteredData
  } : undefined

  return {
    rewardCountRedeemed: resultData,
    rewardCountRedeemedLoading: isLoading,
    rewardCountRedeemedMutate: mutate,
  }
}

export default useGetRewardCountRedeemed
